import { HttpMethod } from "../types/HttpMethod";

const apiUrl = `${process.env.REACT_APP_BASE_URL}/rs/automation/user`;
const ftpUrl = `${process.env.REACT_APP_BASE_URL}/rs/automator/ftp/user`;

export const getByUsernameAndPassword = async (
  username: string,
  password: string
) => {
  const url = `${apiUrl}/${username}`;
  const encodedCredentials = btoa(`${username}:${password}`);
  return fetch(url, {
    method: HttpMethod.Get,
    headers: {
      Authorization: `Basic ${encodedCredentials}`,
    },
  });
};

export const decryptString = async (secretKey: any, inputStr: string) => {
  const url = `${apiUrl}/decrypt/${secretKey}/${inputStr}`;
  return fetch(url, {
    method: HttpMethod.Get,
  });
};

export const resetPassword = async (username: string, newPassword: string) => {
  const url = `${ftpUrl}/reset/password?username=${username}&newPassword=${newPassword}`;
  return fetch(url, {
    method: HttpMethod.Put,
  });
};

export const changePassword = async (
  username: string,
  currentPassword: string,
  newPassword: string
) => {
  const url = `${apiUrl}/changePassword?username=${username}&newPassword=${newPassword}`;
  const encodedCredentials = btoa(`${username}:${currentPassword}`);
  return fetch(url, {
    method: HttpMethod.Put,
    headers: {
      Authorization: `Basic ${encodedCredentials}`,
      "Content-Type": "application/json",
    },
  });
};
